
import { Routes, Route } from 'react-router-dom'
import { Layout } from 'frame'
import { List, New } from './components'

export const ModuleRoutes = () => (
  <Layout>
    <List />
    <Routes>
      <Route path="new" element={<New />} />
    </Routes>
  </Layout>
)

export default ModuleRoutes
